/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationAction {
    getFixupPrototypeFunction() { return RecommendationAction.fixupPrototype; }

    static newInstance(model: Partial<RecommendationAction>): RecommendationAction {
        let obj = Object.assign(new RecommendationAction(), model);
        RecommendationAction.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationAction>): RecommendationAction {
        if (!model) return null;
        return RecommendationAction.newInstance(<RecommendationAction> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationAction) {
        if (!obj) return;

        models.RecommendationAction.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationAction): boolean {
        Object.setPrototypeOf(obj, RecommendationAction.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.input_args) {
            for (let val of this.input_args) {
                models.NamedParameter.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the recommendation action
     */
    name: string;

    /**
     * Type of action to perform
     */
    action_type: models.RecommendationActionType;

    /**
     * Name of the resource associated with the action
     */
    resource_name: string;

    /**
     * Input parameters for the remediation action
     */
    input_args: Array<models.NamedParameter>;

    /**
     * Terms and conditions for performing the recommended action
     */
    terms_and_conditions: string;

}
